import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as api from './api/api.js';
import common from './api/common.js';
import global from './api/global.js';
import print from 'vue-print-nb';
import InNumber from './components/tool/index.js'

Vue.use(ElementUI);
Vue.use(print);
Vue.use(InNumber);
Vue.config.productionTip = false
Vue.prototype.$api = api;
Vue.prototype.$common = common;
Vue.prototype.$global = global;

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')